import React from "react";
import SidebarNav from "@imminently/decisively-ui/SidebarNav";

export const SidebarLogo: React.FC = () => {
  const sidebarNavContext = SidebarNav.useSidebarNav();
  const collapsed = Boolean(sidebarNavContext?.collapsed);

  // @ts-ignore (this is injected by immi)
  const logoPath = window.__ENV__?.APP_LOGO || "/logo.svg";

  if (collapsed) {
    return (
      <div className="flex items-center justify-center">
        <img src={logoPath} alt="logo" className="h-8 w-8 object-contain" />
      </div>
    );
  }

  return (
    <div className="h-10 flex items-center">
      <img src={logoPath} alt="logo" className="h-10 w-auto" />
    </div>
  );
};
